import React from 'react'
import Button from "../button/Button";
import '../Theme.css';
import './CopyBox.css';

function CopyBox({style, data, onClick}) {
    const className = "InfoBox " + style;
    return (
        <Button style={className} text={data} onClick={() => {
            navigator.clipboard.writeText(data)
            if (onClick) onClick();
        }}/>
    );
}

export default CopyBox;
